import { useEffect, useState } from "react";
import AdSection from "../AdSection/AdSection";

const MOBILE_QUERY = "(max-width: 992px)";

function getIsMobileViewport() {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return false;
    }

    return window.matchMedia(MOBILE_QUERY).matches;
}

function ResponsiveAdSection({
    adSlot,
    className = "",
    desktopFormat = "horizontal",
    mobileFormat = "rectangle",
    desktopMinHeight = 150,
    mobileMinHeight = 280,
}) {
    const [isMobile, setIsMobile] = useState(getIsMobileViewport);

    useEffect(() => {
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
            return undefined;
        }

        const mediaQuery = window.matchMedia(MOBILE_QUERY);
        const handleChange = () => setIsMobile(mediaQuery.matches);

        handleChange();

        if (typeof mediaQuery.addEventListener === "function") {
            mediaQuery.addEventListener("change", handleChange);
            return () => mediaQuery.removeEventListener("change", handleChange);
        }

        mediaQuery.addListener(handleChange);
        return () => mediaQuery.removeListener(handleChange);
    }, []);

    return (
        <AdSection
            key={isMobile ? "mobile-ad" : "desktop-ad"}
            adSlot={adSlot}
            adFormat={isMobile ? mobileFormat : desktopFormat}
            className={className}
            fullWidthResponsive
            minHeight={isMobile ? mobileMinHeight : desktopMinHeight}
        />
    );
}

export default ResponsiveAdSection;
